import React from  'react';
import { useState, useEffect } from 'react';

// Import các component từ Material-UI
import { AppBar, Toolbar, Typography, Button, IconButton, Box, Avatar, Slide } from '@mui/material';
import IosShareIcon from '@mui/icons-material/IosShare';
import AddToHomeScreenIcon from '@mui/icons-material/AddToHomeScreen';
import CloseIcon from '@mui/icons-material/Close';

const IosInstallPrompt = () => {
    const [showPrompt, setShowPrompt] = useState(false);

    // Toàn bộ logic phát hiện thiết bị của bạn đã rất tốt, giữ nguyên
    useEffect(() => {
        const isAppleDevice = () => {
            const platform = navigator?.platform || '';
            if (['iPhone', 'iPad', 'iPod'].includes(platform)) return true;
            if (navigator.userAgent.includes('Mac') && 'ontouchend' in document) return true;
            return false;
        };
        
        const isInStandaloneMode = () =>window.ReactNativeWebView ||  window.matchMedia('(display-mode: standalone)').matches;

        // Chỉ hiển thị khi: là thiết bị Apple, VÀ chưa được cài
        if (isAppleDevice() && !isInStandaloneMode()) {
            // Kiểm tra xem người dùng đã từng đóng thông báo này chưa
            const hasClosedPrompt = sessionStorage.getItem('pwaIosInstallPromptClosed');
            if (!hasClosedPrompt) {
                setShowPrompt(true);
            }
        }
    }, []);
    useEffect(()=>{
        setTimeout(()=>{
            setShowPrompt(false);
        },30*1000)
    },[])

    const handleClose = (event, reason) => {
        // Lưu vào sessionStorage để thông báo hiện lại nếu người dùng mở tab mới
        sessionStorage.setItem('pwaIosInstallPromptClosed', 'true');
        setShowPrompt(false);
    };

    // --- PHẦN GIAO DIỆN ĐÃ ĐƯỢC NÂNG CẤP HOÀN TOÀN ---
    return (
        // Hiệu ứng trượt lên từ dưới
        <Slide direction="up" in={showPrompt} mountOnEnter unmountOnExit>
            <AppBar 
                position="fixed" 
                sx={{ 
                    top: 'auto', 
                    bottom: 0, 
                    backgroundColor: 'background.paper', // Tự động đổi màu theo theme light/dark
                    color: 'text.primary',
                    borderTop: '1px solid',
                    borderColor: 'divider',
                    zIndex:999999999999
                }}
            >
                <Toolbar>
                    {/* Nút đóng ở bên trái */}
                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon />
                    </IconButton>

                    {/* Logo ứng dụng */}
                    <Avatar 
                        src="/images/icon.png" // Đường dẫn đến logo của bạn
                        alt="App Icon"
                        sx={{ width: 48, height: 48, ml: 1, mr: 2 }} 
                        variant="rounded"
                    />

                    {/* Nội dung hướng dẫn */}
                    <Box sx={{ flexGrow: 1 }}>
                        <Typography variant="subtitle2" component="div" fontWeight="bold">
                            Cài đặt ứng dụng của chúng tôi!
                        </Typography>
                        <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                            Nhấn vào 
                            <IosShareIcon sx={{ mx: 0.5, fontSize: '1.2rem', verticalAlign: 'middle' }} /> 
                            rồi chọn "Thêm vào MH chính"
                            <AddToHomeScreenIcon sx={{ ml: 0.5, fontSize: '1.2rem', verticalAlign: 'middle' }} />
                        </Typography>
                    </Box>
                </Toolbar>
            </AppBar>
        </Slide>
    );
};

export default IosInstallPrompt;